var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarStroke(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87471 2.46298C7.74893 -0.227239 11.5549 -0.227247 12.4291 2.46298L13.1714 4.74742L15.5735 4.74751C18.4022 4.74762 19.5783 8.36728 17.2899 10.03L15.3466 11.442L16.0888 13.7265C16.9628 16.4168 13.8838 18.6539 11.5952 16.9913L9.6519 15.5795L7.70856 16.9913C5.42003 18.6539 2.34096 16.4168 3.21497 13.7265L3.95715 11.442L2.01392 10.03C-0.274478 8.36729 0.901611 4.74762 3.73032 4.74751L6.13235 4.74742L6.87471 2.46298ZM10.3943 5.6499L9.6519 3.36546L8.90954 5.6499C8.51859 6.85298 7.39746 7.66752 6.13246 7.66757L3.73043 7.66766L5.67366 9.07961C6.69704 9.8232 7.12527 11.1412 6.73441 12.3443L5.99223 14.6288L7.93557 13.217C8.95901 12.4734 10.3448 12.4734 11.3682 13.217L13.3116 14.6288L12.5694 12.3443C12.1785 11.1412 12.6068 9.8232 13.6301 9.07961L15.5734 7.66766L13.1713 7.66757C11.9063 7.66752 10.7852 6.85297 10.3943 5.6499Z",
    fill: "#ECC94B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarStroke);
export default __webpack_public_path__ + "static/media/star-stroke.83aabcf6320ea8388b668caa52189fa5.svg";
export { ForwardRef as ReactComponent };